import { EXPLORE_SLUG } from "types/api/explore";
import {
  NewExploreCoursesResponse,
  NewExploreInstructor,
  NewExploreInstructorsResponse,
  NewExploreLanding,
  NewExploreLandingsResponse,
  NewExploreProduct,
} from "types/api/new-explore";

type ExploreResponse =
  | NewExploreCoursesResponse
  | NewExploreInstructorsResponse
  | NewExploreLandingsResponse;

export const getProductData = (
  exploreData: ExploreResponse | null | undefined,
  slug: EXPLORE_SLUG
):
  | NewExploreProduct[]
  | NewExploreLanding[]
  | NewExploreInstructor[]
  | null => {
  if (!exploreData) return null;

  switch (slug) {
    case EXPLORE_SLUG.COURSE:
      return (exploreData as NewExploreCoursesResponse).products ?? null;
    case EXPLORE_SLUG.INSTRUCTOR:
      return (exploreData as NewExploreInstructorsResponse).instructors ?? null;
    case EXPLORE_SLUG.LANDING:
      return (exploreData as NewExploreLandingsResponse).landings ?? null;
    default:
      return null;
  }
};

export const ScrollTop = () => {
  setTimeout(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, 100);
};
